import { createReducer, on } from '@ngrx/store';

import { LabResult, LabresultModuleState } from '../../models/labresult.model';
import * as labresultActions from '../actions/labresult.actions';

export const labresultReducer = createReducer<LabresultModuleState>(
  {} as LabresultModuleState,

  on(labresultActions.getLabresultsSuccess, (state, { labresults, pagination }) => ({
    ...state,
    labResults: labresults,
    pagination,
  })),

  on(labresultActions.labresultNotFound, (state) => ({
    ...state,
    loadResult: false,
    labResults: [] as LabResult[],
  })),
);
